import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CACHE_KEY = "gg_content_cache";
const ContentContext = createContext(null);

function getCached() {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

export function ContentProvider({ children }) {
  const [content, setContent] = useState(getCached);
  const [loading, setLoading] = useState(!getCached());

  useEffect(() => {
    axios.get(`${API}/content`)
      .then((r) => {
        setContent(r.data);
        try { localStorage.setItem(CACHE_KEY, JSON.stringify(r.data)); } catch {}
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const refresh = () => {
    axios.get(`${API}/content`).then((r) => {
      setContent(r.data);
      try { localStorage.setItem(CACHE_KEY, JSON.stringify(r.data)); } catch {}
    }).catch(() => {});
  };

  return (
    <ContentContext.Provider value={{ content, loading, refresh }}>
      {children}
    </ContentContext.Provider>
  );
}

export function useSiteContent() {
  return useContext(ContentContext);
}
